"use client";
import * as React from "react";
const SvgForestFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M10.67 7 6 0 1.33 7h1.24L0 11.2h4.67V14h2.66v-2.8H12L9.43 7z" }), /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M13.43 7h1.24L10 0 8.4 2.39l3.55 5.31h-1.3l2.14 3.5H16zm-2.1 4.9H8.67V14h2.66z" }));
export {
  SvgForestFilled as default
};
